import React, { useState } from "react";
import LoginForm from "../forms/LoginForm";
import { Redirect } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import HelpPhoto from "../assets/help_photos/ComunicadoCalle100.png";

export const MainCircle = () => {
  return (
    <div className="main-circle">
      <img
        src="https://staticmyintelli.s3.amazonaws.com/app/login/Circulo-logo-myintelli.png"
        alt={"mainCircle"}
      />
      <div className="icon-1">
        <img
          src={"https://staticmyintelli.s3.amazonaws.com/app/login/icono-3.png"}
          alt={"icon1"}
        />
      </div>
      <div className="icon-2">
        <img
          src={"https://staticmyintelli.s3.amazonaws.com/app/login/icono-2.png"}
          alt={"icon2"}
        />
      </div>
      <div className="icon-3">
        <img
          src={"https://staticmyintelli.s3.amazonaws.com/app/login/icono-1.png"}
          alt={"icon3"}
        />
      </div>
      <div className="icon-4">
        <img
          src={"https://staticmyintelli.s3.amazonaws.com/app/login/icono-4.png"}
          alt={"icon4"}
        />
      </div>
      <div className="icon-5">
        <img
          src={"https://staticmyintelli.s3.amazonaws.com/app/login/icono-5.png"}
          alt={"icon5"}
        />
      </div>
      <div className="icon-6">
        <img
          src={"https://staticmyintelli.s3.amazonaws.com/app/login/icono-6.png"}
          alt={"icon6"}
        />
      </div>
    </div>
  );
};

const LoginPage = (props) => {
  const [modalHelp, setModalHelp] = useState(true);
  if (localStorage.token) {
    return <Redirect to="/" />;
  }

  const handleClose = () => {
    setModalHelp(false);
  };

  return (
    <div className="keral-login-page">
      <Dialog className="dialog-help" open={modalHelp} onClose={handleClose}>
        <i onClick={handleClose} className="fas fa-times" />
        <img
          src={
            "https://staticmyintelli.s3.amazonaws.com/keralty/popup_aplicativo.jpg" /* HelpPhoto */
          }
          alt="whiteLogo"
        />
      </Dialog>
      <LoginForm />
    </div>
  );
};

export default LoginPage;
